import {
    BULK_WAVE_HEIGHT_LINE,
    SignificantWaveChart,
} from '@/components/spotter/historicalDataTab/SignificantWaveSection';
import { AlertTriggerReferenceChartProps } from '@/components/spotter/notificationTab/AlertReferenceChart';
import { useAlertsFromForm } from '@/components/spotter/notificationTab/useAlertsFromForm';
import { useSpotterContext } from '@/context/SpotterContext';

export const LINES = [BULK_WAVE_HEIGHT_LINE];

export const SignificantWaveHeightAlertReferenceChart = ({ enabled = false }: AlertTriggerReferenceChartProps) => {
    const { spotterId } = useSpotterContext();
    const alerts = useAlertsFromForm();

    if (!spotterId) {
        return;
    }

    return (
        <SignificantWaveChart
            chartTitle={'Significant wave height alert'}
            spotterId={spotterId}
            queryEnabled={enabled}
            showAlertLines={true}
            scaleToFitAlerts={true}
            lines={LINES}
            alertLines={alerts}
        />
    );
};
